import { withSentryReactRouterV6Routing } from '@sentry/react';
import React, { FC, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '../../../routes';
import LoadingProvider from '../../ui/LoadingProvider/LoadingProvider';

const Login = React.lazy(() => import('../Login/Login'));
const ForgotPassword = React.lazy(
  () => import('../ForgotPassword/ForgotPassword')
);
const ResetPassword = React.lazy(
  () => import('../ResetPassword/ResetPassword')
);
const PageNotFound = React.lazy(() => import('../PageNotFound/PageNotFound'));

const UnauthenticatedRouter: FC = () => {
  const SentryRoutes = withSentryReactRouterV6Routing(Routes);

  return (
    <Suspense fallback={<LoadingProvider loading={true} />}>
      <SentryRoutes>
        <Route path={routes.LOGIN} element={<Login />} />
        <Route path={routes.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={routes.RESET_PASSWORD} element={<ResetPassword />} />
        <Route path={routes.PAGE_NOT_FOUND} element={<PageNotFound />} />
        <Route path={'*'} element={<Navigate to={routes.LOGIN} />} />
      </SentryRoutes>
    </Suspense>
  );
};

export default UnauthenticatedRouter;
